export { default } from './DestinationInformation'
